import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import Link from "next/link";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { ProfileSetting } from "~/components/specifics/vendors/settings/profiles/ProfileSetting";
import type { VendorUser } from "~/models/VendorUser";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

type Props = {
	vendorUser: VendorUser;
};

export function Page({ vendorUser }: Props) {
	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "プロフィール詳細" }
						]}
					/>
				</div>
				<ProfileSetting loginVendorUser={vendorUser} />
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
}
